import React from 'react';

import AgentChat from './AgentChat';
import { AGENT_SURFACE, type AgentSurface } from './AgentChatSessionProvider';

type Props = {
  chatComponent?: React.ComponentType<{ isFullPage?: boolean; surface?: AgentSurface }>;
};

/** AI assistant visual surface after retirement of the legacy completion UI. */
const AIAssistant: React.FC<Props> = ({ chatComponent: ChatComponent = AgentChat }) => {
  return <ChatComponent surface={AGENT_SURFACE.SIDE_PANEL} />;
};

export default AIAssistant;
